export default "__VITE_ASSET__4HSMEaN4__"